var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('ve-line',{attrs:{"data":_vm.optionData.data,"settings":_vm.optionData.settings,"legend":_vm.optionData.legend,"yAxis":_vm.optionData.yAxis,"grid":_vm.optionData.grid,"colors":_vm.optionData.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }